import { ChangeEvent, useRef } from 'react';

import { files as fileHelpers, FilesNamespace } from '@/shared/helpers';
import { BaseProps } from '@/shared/types';
import { Button } from '@/shared/uikitV2/Button';

export type BrowseFilesProps = BaseProps<{
  acceptFiles?: FilesNamespace;
  disabled?: boolean;
  onFilesSelect?: (files: File[]) => void;
}>;

export const BrowseFiles = ({
  acceptFiles = 'attachments',
  children,
  disabled,
  style,
  onFilesSelect,
}: BrowseFilesProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const inputAccept = fileHelpers.getFileInputAccept(acceptFiles);

  const onOpenFilePicker = () => {
    if (disabled) return;

    inputRef.current?.click();
  };

  const onChange = (ev: ChangeEvent<HTMLInputElement>) => {
    const pickedFiles = Array.from(ev.target.files ?? []);

    if (!pickedFiles.length) return;
    onFilesSelect?.(pickedFiles);

    // allow selecting the same file again in the next interaction
    ev.target.value = '';
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        multiple={true}
        accept={inputAccept}
        onChange={onChange}
        style={{ display: 'none' }}
      />
      <Button type="secondary" style={style} onClick={onOpenFilePicker} disabled={disabled}>
        {children}
      </Button>
    </>
  );
};
